const FormatMoney = (value, fractionDigits = 2, zeroAllowed = true) => {
  if (!value) return value;

  let factor = 100;
  let defaultFractionDigits = 2;

  while (defaultFractionDigits < fractionDigits) {
    factor *= 10;
    defaultFractionDigits += 1;
  }

  let result = value;
  if (typeof result === 'number') {
    return result.toLocaleString('pt-BR', { minimumFractionDigits: fractionDigits, style: 'currency', currency: 'BRL' });
  }
  result = result.toString();
  result = result.replace(/\D/gi, '');
  if (result) {
    result = parseFloat(result);
    result /= factor;
    if (!zeroAllowed && result === 0.00) return '';
    result = result.toLocaleString('pt-BR', { minimumFractionDigits: fractionDigits, style: 'currency', currency: 'BRL' });
    return result;
  }
  return '';
};

export default FormatMoney;
